export const CHEFE_DE_OFICINA = () => `/chefe-de-oficina`;
